import { all, put, retry } from 'redux-saga/effects';
import { authClient } from '../api/Client';
import { reject, resolve } from '../api';
import * as types from '../constants';
import { NOTIFICATION } from '../constants';
import {
  errorNotification,
  showNotification,
  successNotification,
} from '../../shared-components/Notifications';

export function* loadDashboards() {
  try {
    const res = yield retry(4, 500, authClient?.Dashboard?.list);

    yield put({
      type: resolve(types?.LOAD_DASHBOARDS),
      payload: res?.data()?.results,
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_DASHBOARDS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types?.LOAD_DASHBOARDS)),
      }),
    ]);
  }
}

export function* loadDashboardDetails({ uuid }) {
  try {
    const res = yield retry(4, 500, authClient?.Dashboard?.details, { uuid });

    yield put({
      type: resolve(types?.LOAD_DASHBOARD_DETAILS),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_DASHBOARD_DETAILS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_DASHBOARD_DETAILS),
        ),
      }),
    ]);
  }
}

export function* createDashboard({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.Dashboard?.create, {
      body: data,
    });
    yield put({
      type: resolve(types?.CREATE_DASHBOARD),
      payload: res?.data(),
    });
    showNotification(
      successNotification({
        statusCode: 200,
        message: 'Dashboard has been created',
      }),
    );
  } catch (error) {
    yield all([
      put({
        type: reject(types?.CREATE_DASHBOARD),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types?.CREATE_DASHBOARD)),
      }),
    ]);
  }
}

export function* updateDashboard({ dashboard }) {
  try {
    // const res = yield retry(4, 500, authClient.Dashboard.update, {
    //   body: dashboard,
    //   uuid: dashboard.uuid,
    // });
    yield put({
      type: resolve(types?.UPDATE_DASHBOARD),
      // payload: res?.data(),
      payload: dashboard,
    });
    showNotification(
      successNotification({
        statusCode: 200,
        message: 'Dashboard has been updated',
      }),
    );
  } catch (error) {
    yield all([
      put({
        type: reject(types?.UPDATE_DASHBOARD),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types?.UPDATE_DASHBOARD)),
      }),
    ]);
  }
}

export function* deleteDashboard({ dashboard }) {
  try {
    yield retry(4, 500, authClient?.Dashboard?.delete, {
      uuid: dashboard?.uuid,
    });
    yield put({
      type: resolve(types?.DELETE_DASHBOARD),
      uuid: dashboard?.uuid,
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.DELETE_DASHBOARD),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types?.DELETE_DASHBOARD)),
      }),
    ]);
  }
}

export function* loadWidgets() {
  try {
    const res = yield retry(4, 500, authClient?.Dashboard?.loadWidgets);
    yield put({
      type: resolve(types?.LOAD_WIDGETS),
      payload: res?.data()?.results,
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_WIDGETS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types?.LOAD_WIDGETS)),
      }),
    ]);
  }
}

export function* updateDashboardCell({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.Dashboard?.updateCell, {
      body: {
        uuid: data?.uuid,
        widget: data?.widget?.uuid || null,
      },
      uuid: data?.uuid,
    });
    yield put({
      type: resolve(types?.UPDATE_DASHBOARD_CELL),
      payload: res?.data(),
      data,
      widget: data?.widget,
    });
    showNotification(
      successNotification({
        statusCode: 200,
        message: 'Dashboard widget has been updated',
      }),
    );
  } catch (error) {
    yield all([
      put({
        type: reject(types?.UPDATE_DASHBOARD_CELL),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.UPDATE_DASHBOARD_CELL),
        ),
      }),
    ]);
  }
}
